import React from 'react';

import StockColorPickerSelect from '@/components/StockColorPickerSelect';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarColors,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  getColorOptions,
  handleChangeColorMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import { ColorOptionType } from '@/components/StockColorPicker/types';

function ColorFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedColors =
    useTypedSelector(getSelectedFilters).selectedParams.selectedColors;

  const colorOptions = getColorOptions(stockFilterParams);

  const handleChangeColor = (color: ColorOptionType) => {
    dispatch(setCarColors(handleChangeColorMultiSelect(color, selectedColors)));
    dispatch(setPage(1));
  };

  const handleClearColor = () => {
    dispatch(setCarColors([]));
    dispatch(setPage(1));
  };

  return (
    <StockColorPickerSelect
      label="Цвет"
      colors={colorOptions}
      selectedColors={selectedColors}
      onChange={handleChangeColor}
      onClear={handleClearColor}
    />
  );
}

export default ColorFilter;
